import CardToCard from "@/components/CardToCard/CardToCard";
import CardToCardNewVersion from "@/components/CardToCard/NewVersion/CardToCardNewVersion";
import perfectMoneyNewVersion from "@/components/PerfectMoney/NewVersion/PerfectMoneyNewVersion";
import ShaparakNewVersion from "@/components/Shaparak/NewVersion/ShaparakNewVersion";
import directBankNewVersion from "@/components/Shetab/NewVersion/DirectBankNewVersion";
import paymentInformationNewVersion from "@/components/Shetab/NewVersion/PaymentInformationNewVersion";
import shetabFinalNewVersion from "@/components/Shetab/NewVersion/ShetabFinalNewVersion";
import shetabValidationNewVersion from "@/components/Shetab/NewVersion/ShetabValidationNewVersion";
import paymentInformation from "@/components/Shetab/PaymentInformation";
import shetabFinal from "@/components/Shetab/ShetabFinal";
import shetabValidation from "@/components/Shetab/ShetabValidation";
import TetherNewVersion from "@/components/Tether/NewVersion/TetherNewVersion";
import Tether from "@/components/Tether/Tether";
import TronNewVersion from "@/components/Tron/NewVersion/TronNewVersion";
import Tron from "@/components/Tron/Tron";
import AccountToAccount from "../components/AccountToAccount/AccountToAccount.vue";
import AccountToAccountNewVersion from "../components/AccountToAccount/NewVersion/AccountToAccountNewVersion.vue";
import Bitcoin from "../components/Bitcoin/Bitcoin";
import CryptoGroup from "../components/CryptoGroup/CryptoGroup.vue";
import CryptoGroupNewVersion from "../components/CryptoGroup/NewVersion/CryptoGroupNewVersion.vue";
import IndirectGroup from "../components/IndirectGroup/IndirectGroup.vue";
import IndirectGroupNewVersion from "../components/IndirectGroup/NewVersion/IndirectGroupNewVersion.vue";
import perfectMoney from "../components/PerfectMoney/PerfectMoney";
import Shaparak from "../components/Shaparak/Shaparak";
import directBank from "../components/Shetab/DirectBank";
import TetherBep20NewVersion from "../components/Tether-Bep20/NewVersion/TetherBep20NewVersion.vue";
import TetherBep20 from "../components/Tether-Bep20/TetherBep20.vue";
import TetherErc20NewVersion from "../components/Tether-Erc20/NewVersion/TetherErc20NewVersion.vue";
import TetherErc20 from "../components/Tether-Erc20/TetherErc20.vue";
import VatanErc20NewVersion from "../components/Vatan-Erc20/NewVersion/VatanErc20NewVersion.vue";
import VatanErc20 from "../components/Vatan-Erc20/VatanErc20.vue";
import VouchersNewVersion from "../components/Vouchers/NewVersion/VouchersNewVersion.vue";
import Vouchers from "../components/Vouchers/Vouchers.vue";
import BitcoinNewVersion from "../components/Bitcoin/NewVersion/BitcoinNewVersion.vue";
// import Vue from "vue";
// import {store} from "@/store/store";

export const routes = [
  {
    path: "/bitcoin",
    components: {
      body: Bitcoin,
      newVersionBody: BitcoinNewVersion,
    },
    alias: "/v2/bitcoin",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/",
    components: {
      body: directBank,
      newVersionBody: directBankNewVersion,
    },
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
    // beforeEnter: (to, from, next) => {
    //     const queryId = to.query.id;
    //     store.state.globalApiRequestPending = true;
    //     console.log(store.state.globalApiRequestPending);
    //     if (!to.query.id){
    //         //id not available
    //         // explicitly return false to cancel the navigation
    //         return false;
    //     }
    //     Vue.http.get(`payments/${queryId}`).then(
    //         (res) => {
    //             to.meta["resolvedData"] = res.body.data.inputs;
    //             console.log(res.body.data.inputs);
    //             next();
    //             store.state.globalApiRequestPending = false;
    //         },
    //         (error) => {
    //             console.log(error);
    //             Vue.swal.fire({
    //                 icon: 'error',
    //                 showConfirmButton: true,
    //                 confirmButtonText: 'متوجه شدم',
    //                 timer: 10000,
    //                 text: error.body.message,
    //             });
    //             store.state.globalApiRequestPending = false;
    //
    //             // explicitly return false to cancel the navigation
    //             return false;
    //         }
    //     );
    // },
    alias: "/v2/",
  },
  {
    path: "/shetab/validation",
    components: {
      body: shetabValidation,
      newVersionBody: shetabValidationNewVersion,
    },
    alias: "/v2/shetab/validation",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/shetab/payment-info",
    components: {
      body: paymentInformation,
      newVersionBody: paymentInformationNewVersion,
    },
    alias: "/v2/shetab/payment-info",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/shetab/final",
    components: {
      body: shetabFinal,
      newVersionBody: shetabFinalNewVersion,
    },
    alias: "/v2/shetab/final",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/perfect-money",
    components: {
      body: perfectMoney,
      newVersionBody: perfectMoneyNewVersion,
    },
    alias: "/v2/perfect-money",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/vouchers",
    components: {
      body: Vouchers,
      newVersionBody: VouchersNewVersion,
    },
    alias: "/v2/vouchers",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/shaparak",
    components: {
      body: Shaparak,
      newVersionBody: ShaparakNewVersion,
    },
    alias: "/v2/shaparak",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/tether",
    components: {
      body: Tether,
      newVersionBody: TetherNewVersion,
    },
    alias: "/v2/tether",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/tether-bep20",
    components: {
      body: TetherBep20,
      newVersionBody: TetherBep20NewVersion,
    },
    alias: "/v2/tether-bep20",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/tether-erc20",
    components: {
      body: TetherErc20,
      newVersionBody: TetherErc20NewVersion,
    },
    alias: "/v2/tether-erc20",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/vatan-erc20",
    components: {
      body: VatanErc20,
      newVersionBody: VatanErc20NewVersion,
    },
    alias: "/v2/vatan-erc20",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/tron",
    components: {
      body: Tron,
      newVersionBody: TronNewVersion,
    },
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
    // alias: '/v2/tether'
  },
  {
    path: "/crypto-group",
    components: {
      body: CryptoGroup,
      newVersionBody: CryptoGroupNewVersion,
    },
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/ctc",
    components: {
      body: CardToCard,
      newVersionBody: CardToCardNewVersion,
    },
    alias: "/v2/ctc",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/ata",
    components: {
      body: AccountToAccount,
      newVersionBody: AccountToAccountNewVersion,
    },
    alias: "/v2/ata",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
  {
    path: "/indirect",
    components: {
      body: IndirectGroup,
      newVersionBody: IndirectGroupNewVersion,
    },
    alias: "/v2/indirect",
    beforeRouteEnter: (to, from, next) => {
      if (to.path === from.path) {
        // Prevent redundant navigation
        return;
      }

      // Continue with the navigation
      next();
    },
  },
];
